import toast from 'react-hot-toast';

export const isFormValid = (formData) => {
  if (formData.naziv === '' || formData.naziv === null) {
    toast.error('Naziv je obavezno polje.');
    return true;
  }
  if (
    formData.vrednost === '' ||
    formData.vrednost === null ||
    formData.vrednost === 0
  ) {
    toast.error('Vrednost mere  je obavezno polje.');
    return true;
  }

  return false;
};
